import router from '@/router';

export default {
  state:
  {
    searchVal: '',
    detailData: {},
    integralData: {}
  },
  getters:
  {

  },
  mutations:
  {
    getDetailData(state: any, data: any) {
      state.detailData = data
    },
    getIntegralData(state: any, data: any) {
      state.integralData = data
    }
  },
  actions:
  {
    async getMemberDetailByQrCode({ commit, state }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
        params.searchType = 3
        const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
        if (success) {
          router.app.$router.push({
            path: "/faceIntegral/IntegralMember",
            query: { val: params.searchText, type: params.searchType }
          });
        }
        if (error) {
          params.searchType = 3
          const { error, success }: any = await router.app.$request('SEARCH_MEMBER_QRCODE', params);
          if (success) {
            router.app.$router.push({
              path: "/faceIntegral/IntegralMember",
              query: { val: params.searchText, type: params.searchType }
            });
          }
          error && router.app.$dialog({ message: error.msg });
        }
      return { error, success };
    },
    async getMemberDetail({ commit, state }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      params.searchType = 1
      const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
      if (success) {
        router.app.$router.push({
          path: "/faceIntegral/IntegralMember",
          query: { val: params.searchText, type: params.searchType }
        });
      }
      if (error) {
        params.searchType = 3
        const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
        if (success) {
          router.app.$router.push({
            path: "/faceIntegral/IntegralMember",
            query: { val: params.searchText, type: params.searchType }
          });
        }
        error && router.app.$dialog({ message: error.msg });
      }
      return { error, success };
    },
    async getMemberDetailData({ commit, state }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
      if (success) {
        commit('getDetailData', success.data);
      }
      return { error, success };
    },
    async recordScore({commit, state}:any, params:any) {
      const { error, success }: any = await router.app.$request('FACEINTEGRAL_SCORE_GET', params);
      if (success) {
        commit('getIntegralData', success.data);
        router.app.$router.push({
          path: "/faceIntegral/IntegralSuccess",
          query: {}
        });
      }
      error && router.app.$dialog({ message: error.msg });
    }
  },
};
